import React, { useState } from 'react';
import StudentSearch from '../SearchStudent';
import useAutoFocus from '../../Utils/autoFocus';
import { Postdata } from '../../API/GlobalApi';
import Notifier from '../../Utils/notify';
import '../../assets/css/Modal.css';
import '../../assets/css/StudentShortDetails.css';

export const AddDefaulterModal = ({ isOpen, onClose, onSuccess }) => {
    const nameInputRef = useAutoFocus(isOpen);
    const [studentsData, setStudentsData] = useState({});
    const [remark, setRemark] = useState('');
    const [resetSearchKey, setResetSearchKey] = useState(0);
    const [loading, setLoading] = useState(false);

    const handleClose = () => {
        setStudentsData({});
        setRemark('');
        setResetSearchKey(prev => prev + 1);
        onClose();
    };

    const handleAdd = async () => {
        if (!studentsData?.user_id) {
            Notifier.warn('Please search and select a student first.');
            return;
        }
        if (!remark.trim()) {
            Notifier.warn('Please enter a remark / reason.');
            return;
        }
        setLoading(true);
        try {
            const response = await Postdata('students/defaulter-list/', {
                student_id: studentsData.user_id,
                remark: remark.trim(),
            });
            if (response?.error || response?.detail) {
                Notifier.error(response.error || response.detail || 'Failed to add defaulter.');
            } else {
                Notifier.success('Student added to defaulters list.');
                onSuccess && onSuccess();
                handleClose();
            }
        } catch {
            Notifier.error('Something went wrong.');
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    const studentName = studentsData?.profile_name === 'Student'
        ? [studentsData?.salutation, studentsData?.first_name, studentsData?.middle_name, studentsData?.last_name]
            .filter(v => v && v.trim())
            .join(' ')
        : studentsData?.full_name || '';

    return (
        <div className="modal-overlay">
            <div
                className="modal-content"
                style={{ position: 'relative', width: '50%', maxHeight: '90vh', overflowY: 'auto' }}
            >
                {/* Header */}
                <div
                    className="modal-header-content"
                    style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}
                >
                    <h2 className="text-primary">Add Defaulter</h2>
                    <button className="close-btn" onClick={handleClose}>
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <path d="M1 1L13 13M13 1L1 13" stroke="#333" strokeWidth="2" strokeLinecap="round" />
                        </svg>
                    </button>
                </div>

                {/* Student Search */}
                <div className="mb-3">
                    <StudentSearch
                        nameInputRef={nameInputRef}
                        resetTrigger={resetSearchKey}
                        setStudentsData={setStudentsData}
                    />
                </div>

                {/* Details Panel */}
                <div className="row" style={{ background: '#F9FAFC', padding: '12px', borderRadius: '8px', marginBottom: '16px' }}>
                    <div className="col-md-3">
                        <h4 className="fm-pr-hd">DETAILS</h4>
                    </div>

                    <div className="col-md-12 mt-2">
                        <div className="row">
                            <div className="col-md-4">
                                <div className="student-details" style={{ textAlign: 'left' }}>
                                    {studentsData?.profile_name === 'Student' && (
                                        <div>
                                            <p className="sd-p">Reg No</p>
                                            <p className="n-p-t">{studentsData?.permanent_registration_number || '—'}</p>
                                        </div>
                                    )}
                                    <div>
                                        <p className="sd-p">Name</p>
                                        <p className="n-p-t">{studentName || '—'}</p>
                                    </div>
                                    <div>
                                        <p className="sd-p">Contact No</p>
                                        <p className="n-p-t">{studentsData?.mobile || '—'}</p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4">
                                <div>
                                    <p className="sd-p">Profile type</p>
                                    <p className="n-p-t">{studentsData?.profile_name || '—'}</p>
                                </div>
                                {studentsData?.profile_name === 'Student' && (
                                    <div className="mt-2">
                                        <p className="sd-p">Course</p>
                                        <p className="n-p-t">{studentsData?.lag?.display || '—'}</p>
                                    </div>
                                )}
                            </div>

                            <div className="col-md-4 d-flex justify-content-center">
                                {studentsData?.profile_picture?.url && (
                                    <img
                                        src={`${process.env.REACT_APP_API_BASE_URL}${studentsData.profile_picture.url}`}
                                        alt="Student"
                                        style={{
                                            width: '120px',
                                            height: '120px',
                                            objectFit: 'cover',
                                            borderRadius: '8px',
                                            marginBottom: '15px',
                                        }}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Remark */}
                <div className="mb-4">
                    <label style={{ fontWeight: 600, fontSize: '14px', marginBottom: '6px', display: 'block' }}>
                        Remark <span style={{ color: 'red' }}>*</span>
                    </label>
                    <textarea
                        rows={3}
                        value={remark}
                        onChange={e => setRemark(e.target.value)}
                        onKeyDown={e => {
                            if (e.key === 'Enter' && !e.shiftKey) {
                                e.preventDefault();
                                handleAdd();
                            }
                        }}
                        placeholder="Reason for adding as defaulter..."
                        style={{
                            width: '100%',
                            border: '1px solid #ddd',
                            borderRadius: '8px',
                            padding: '10px',
                            fontSize: '14px',
                            resize: 'vertical',
                            outline: 'none',
                        }}
                    />
                </div>

                {/* Footer */}
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                    {/* <button
                        onClick={handleClose}
                        style={{
                            padding: '8px 20px',
                            borderRadius: '8px',
                            border: '1px solid #ccc',
                            background: '#fff',
                            cursor: 'pointer',
                            fontSize: '14px',
                        }}
                    >
                        Cancel
                    </button> */}
                    <button
                        onClick={handleAdd}
                        disabled={loading}
                        style={{
                            padding: '8px 20px',
                            borderRadius: '8px',
                            border: 'none',
                            background: '#7F56DA',
                            color: '#fff',
                            cursor: loading ? 'not-allowed' : 'pointer',
                            fontSize: '14px',
                            opacity: loading ? 0.7 : 1,
                        }}
                    >
                        {loading ? 'Adding...' : 'Add Defaulter'}
                    </button>
                </div>
            </div>
        </div>
    );
};
